import { render, staticRenderFns } from "./index.vue?vue&type=template&id=91344444&scoped=true&lang=pug"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=91344444&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91344444",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspaces/wuwow-junior-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('91344444')) {
      api.createRecord('91344444', component.options)
    } else {
      api.reload('91344444', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=91344444&scoped=true&lang=pug", function () {
      api.rerender('91344444', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parents/profileInfo/infoCard/editInfoCard/index.vue"
export default component.exports